// @flow
import styled from 'styled-components'
import { Table, Row } from 'antd'

export const StyledTable = styled(Table)`
  padding-bottom: 30px;
`

export const StyledRow = styled(Row)`
  padding-top: 20px;
  & button {
    width: 100%;
  }
`



// WEBPACK FOOTER //
// ./src/components/form-calculator-greeks/style.js